import { Sources, StatusBadge } from "../components/ui";
import { useStore } from "../store";
import { useHash } from "../components/ui";

export function World() {
  const { world, bible } = useStore();
  const [, navigate] = useHash();
  return (
    <div className="grid">
      <h1>Monde</h1>
      {world.lore.map((block) => (
        <section key={block.id} className="card">
          <h2>{block.title}</h2>
          <p>{block.body}</p>
          <Sources sources={block.sources} />
        </section>
      ))}
      <section className="card">
        <h2>Guildes</h2>
        {world.guilds.map((g) => (
          <p key={g.id}><strong>{g.name}</strong> — {g.summary}</p>
        ))}
      </section>
      <section className="card">
        <h2>Classes</h2>
        {world.classes.map((c) => (
          <p key={c.id}><strong>{c.name}</strong> — {c.description}</p>
        ))}
      </section>
      <section className="card">
        <h2>Fragments</h2>
        <p className="tiny">Cinq porteurs établis. Aucun sixième. Les noms absents des sources restent vides.</p>
        {world.fragments.map((f) => {
          const bearer = bible?.characters.find((c) => c.id === f.bearerId);
          return (
            <p key={f.id}>
              <strong>{f.name ?? "Nom non confirmé"}</strong> · {bearer?.name} — {f.description}
            </p>
          );
        })}
      </section>
      <section className="card">
        <h2>Lieux</h2>
        {world.locations.map((l) => (
          <p key={l.id}><strong>{l.name}</strong> ({l.kind}) — {l.description}</p>
        ))}
      </section>
      <section className="card">
        <h2>Tomes prévus (titres connus seulement)</h2>
        {world.plannedBooks.map((b) => (
          <p key={b.id}>{b.number}. {b.title} <StatusBadge status={b.status} /></p>
        ))}
        <p className="tiny">Les titres des tomes 4 à 7 ne sont pas inventés.</p>
      </section>
      <button className="btn" type="button" onClick={() => navigate("/arcs")}>Arcs narratifs</button>
    </div>
  );
}

export function Arcs() {
  const { world } = useStore();
  return (
    <div>
      <h1>Arcs narratifs</h1>
      <div className="grid grid-2">
        {world.arcs.map((a) => (
          <article key={a.id} className="card">
            <div className="row space">
              <h3>{a.title}</h3>
              <span className="badge time">{a.state}</span>
            </div>
            <p>{a.summary}</p>
            <Sources sources={a.sources} />
          </article>
        ))}
      </div>
    </div>
  );
}
